import styled from 'styled-components'
import { styled as muiStyled } from '@mui/material/styles'
import Cancel from '@mui/icons-material/Cancel'

export const DosageWidth = styled.div`
  position: relative;
  width: 55px;
`

export const DeleteIcon = muiStyled(Cancel)(
  ({ theme }) => `
  position: absolute;
  color: ${theme.palette.error.main};
  cursor:pointer;
  background: ${theme.palette.background.dialogBackground};
  top: -8px;
  right: -8px;
  font-size: 18px;
  border-radius: 30px;
  padding: 1px;
`,
)
